import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthResult, Session, User } from "@/lib/api";

interface AuthState {
  session: Session | null;
  user: User | null;
  setAuth: (result: AuthResult) => void;
  setUser: (user: User) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      user: null,
      setAuth: (result) =>
        set({
          session: {
            access_token: result.access_token,
            refresh_token: result.refresh_token,
          },
          user: result.user,
        }),
      setUser: (user) => set({ user }),
      clear: () => set({ session: null, user: null }),
    }),
    {
      name: "ai_photo_v3_session",
      partialize: (state) => ({ session: state.session, user: state.user }),
    }
  )
);

// Derived selector — pure, no get(), no method call. Safe with
// useSyncExternalStore snapshot semantics.
export const selectIsAuthenticated = (s: AuthState) =>
  Boolean(s.session?.access_token && s.user);
